import React from "react";

const SubscribeMessage = ({ error, success }) => (
    <>
        {error && <p className="errors">{error}</p>}
        {success && <p className="success">Subscribed successfully!</p>}
    </>
);

export default SubscribeMessage;
